import { render, staticRenderFns } from "./product_user2.vue?vue&type=template&id=542ead74&scoped=true&"
import script from "./product_user2.vue?vue&type=script&lang=js&"
export * from "./product_user2.vue?vue&type=script&lang=js&"
import style0 from "./product_user2.vue?vue&type=style&index=0&id=542ead74&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542ead74",
  null
  
)

export default component.exports